import { Component } from '@angular/core';

@Component({
	selector: 'app-bootstrap',
	template: '<router-outlet></router-outlet>'
})
export class BootstrapComponent {
	title = 'pc-app';
}
